import * as $ from 'jquery';
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-bs4/js/dataTables.bootstrap4';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.flash';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-select/js/dataTables.select';
import 'datatables.net-responsive/js/dataTables.responsive';
import * as moment from 'moment';
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min';
import * as select2 from 'select2/dist/js/select2.full.js';
import axios, {AxiosResponse} from 'axios';
import {IPage} from "./interfaces/IPage";
import {Ship} from "./frontend/Ship";
import {BasePage} from "./frontend/BasePage";
import {Trip} from "./frontend/Trip";
import {TableScroller} from "./TableScroller";

declare global {
    interface Window {
        language: string,
        frontend: Frontend;
        translations: {
            copyButton,
            csvButton,
            excelButton,
            pdfButton,
            printButton,
            colvisButton,
            selectAllButton,
            selectNoneButton,
            datatables: { de, en }
        };
        _token: string;
        $: JQueryStatic;
        jQuery: JQueryStatic;
        setUsersListFilterRoleSelectValues: () => void;
        scroller: TableScroller|undefined;
    }
}

export {axios, $, moment, select2, bootstrap};
window.$ = $;
window.jQuery = $;

export class Frontend {
    static modules = [
        BasePage,
        Ship,
        Trip,
    ];

    registeredModules: Array<IPage> = [];

    register() {
        Frontend.modules.forEach((page) => {
            const module = new page();
            if (module.runOnCurrentPage()) {
                this.registeredModules.push(module);
            }
        })
    }
}

const frontend = new Frontend();
window.frontend = frontend;

$(() => {
    frontend.register();
})
